<template>
  <div>
    <DatePicker
      v-model:date="date"
      :years-start-ago="yearsStartAgo"
      :years-end-in="yearsEndIn"
      :has-errors="hasErrors"
    ></DatePicker>
    <input
      id="edit_profile_form_date_of_birth"
      type="hidden"
      name="edit_profile_form[date_of_birth]"
      :value="dateOfBirthForInput"
    />
  </div>
</template>

<script setup lang="ts">
import DatePicker from './DatePicker.vue';
import { computed, ref } from 'vue';

const currentDate = new Date();

type Props = {
  // スネークケースとなっているが、原因は date_of_birth_formable.rb から @props_data.to_json として渡されており、そのキーに依存しているためこのケースとなっている。修正する場合は JSON 変換時にキーをキャメル（ケバブ？）ケースに変換する必要がある
  date_of_birth?: string;
  default_date_of_birth?: string;
  max_age: number;
  errors?: { date_of_birth?: string[] };
};

const {
  date_of_birth: dateOfBirth,
  default_date_of_birth: defaultDateOfBirth,
  max_age: maxAge,
  errors,
} = defineProps<Props>();

type DateOptionValue = Date | undefined;

const date = ref<DateOptionValue>();
if (dateOfBirth) {
  date.value = new Date(dateOfBirth);
} else if (defaultDateOfBirth) {
  date.value = new Date(defaultDateOfBirth);
}

const dateOfBirthForInput = computed(() =>
  date?.value?.toISOString()?.split('T'),
);

const hasErrors = (errors?.date_of_birth?.length ?? 0) > 0;

const yearsStartAgo = computed(() =>
  date.value
    ? // 生年月日のDatePickerに何年前まで年を表示するか。DatePickerのpropsであるyearsStartAgoは現在選択されてる年齢を基点に計算するため、
      // 「120才まで入力できるようにする」とした場合、誕生年で2000年が選ばれていると、1880年まで表示されてしまう。なので、
      // 現在の年を基点に120年前まで表示するようにこのような計算をしている
      date.value.getFullYear() - (currentDate.getFullYear() - maxAge)
    : // 未設定の場合は maxAge で指定された年数分前の年を表示する
      maxAge,
);

const yearsEndIn = computed(() =>
  date.value
    ? // yearsEndIn(何年後まで「年」のプルダウンを表示するか)もyearsStartAgo同様に現在選択されてる年齢を基点に表示するため、
      // 「今年まで」のプルダウンを表示するためにこのような計算をする
      currentDate.getFullYear() - date.value.getFullYear()
    : // 未設定の場合は今年まで表示する
      0,
);
</script>
